import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 集計アラートの表示状態を変更する
 */
export class UpdateAlertVisibilityUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 集計アラートの表示状態を変更する
   * @param aggregateBusinessIds - 変更する集計ID配列
   * @param isDismissed - 非表示にするかどうか
   */
  public async execute(aggregateBusinessIds: string[], isDismissed: boolean): Promise<INetworkResult<void, IError>> {
    const networkResult = await this.repository.putAlertVisibility(aggregateBusinessIds, isDismissed);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      case 'error':
      default:
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
